import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

import exportKey from "../static/exportKey";

export default {
    exportInvoice({ commit }, { idInvoice }) {
        let query = {
            idmasal_transaksi: idInvoice,
        };

        let formData = new FormData();
        formData.append("type", exportKey.invoice.job);
        formData.append("filter_json", JSON.stringify(query));

        commit("toggleExport", true);
        conn.post(api.export.job, formData, conn.contentType.form)
            .then((response) => {
                let { status, msg, data } = response.data;
                if (status === true) {
                    localStorage.setItem("key_export_tracker", exportKey.invoice.tracker);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg, data));
                    commit("toggleExport", false);
                }
            })
            .catch((e) => {
                commit("toggleExport", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    exportLampiran({ commit }, { idInvoice }) {
        let query = {
            idmasal_transaksi: idInvoice,
        };

        let formData = new FormData();
        formData.append("type", exportKey.lampiran.job);
        formData.append("filter_json", JSON.stringify(query));

        commit("toggleExport", true);
        conn.post(api.export.job, formData, conn.contentType.form)
            .then((response) => {
                let { status, msg, data } = response.data;
                if (status === true) {
                    localStorage.setItem("key_export_tracker", exportKey.lampiran.tracker);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg, data));
                    commit("toggleExport", false);
                }
            })
            .catch((e) => {
                commit("toggleExport", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    async trackerExport(state) {
        try {
            let keyExport = localStorage.getItem("key_export_tracker");
            if (keyExport === null) {
                return resulter.errorResult();
            }
            let query = {
                key: keyExport,
            };

            const tracker = await conn.get(api.export.track, query);

            if (!tracker.data) {
                throw tracker;
            }

            if (!tracker.data.status) {
                return resulter.errorResult(tracker.data.msg, tracker.data.data);
            } else {
                return resulter.successResult(tracker.data.msg, tracker.data.data);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async exportDeleteMaster(state) {
        try {
            let query = {
                key: localStorage.getItem("key_export_tracker"),
            };
            const res = await conn.get(api.export.delete.master, query);
            if (!res.data) {
                throw res;
            }
            if (res.data.code === 200) {
                localStorage.removeItem("key_export_tracker");
                return resulter.successResult(res.data.msg, res.data.data);
            } else {
                return resulter.errorResult(res.data.msg, res.data.data);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async exportDeleteCluster(state, key) {
        try {
            let query = {
                key,
            };
            const res = await conn.get(api.export.delete.cluster, query);
            if (!res.data) {
                throw res;
            }

            if (res.data.code !== 200) {
                return resulter.errorResult(res.data.msg, res.data.data);
            } else {
                return resulter.errorResult(res.data.msg, res.data.data);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
};
